import { IRegister } from "../models/IRegister";
import { IRegisterResponse } from "../models/IRegisterResponse";
import { ICustomerProfile } from "../models/ICustomerProfile";
import { configWithWebToken, configWithUserToken } from "./config";

export interface IApiError {
  code: string;
  description: string;
}

export const register = (data: IRegister) => {
  return configWithWebToken.post<IRegisterResponse>("Auth/Register", data, {
    headers: { "Idempotency-Key": crypto.randomUUID() },
  });
};

export const getCustomerProfile = () => {
  return configWithUserToken.get<ICustomerProfile>("Auth/CustomerDetailsByToken");
};

export const updateUserProfile = (userId: string, body: { customerTelNo?: string; customerBirthDate?: string; customerEmail?: string }) => {
  return configWithUserToken.put(`Auth/UpdateUserProfile/${userId}`, body);
};

export const deleteAccount = (userId: string) => {
  return configWithUserToken.delete(`Auth/RemoveUser/${userId}`);
};
